import { render, staticRenderFns } from "./googleSearchText.vue?vue&type=template&id=df845522&scoped=true"
import script from "./googleSearchText.vue?vue&type=script&lang=js"
export * from "./googleSearchText.vue?vue&type=script&lang=js"
import style0 from "./googleSearchText.vue?vue&type=style&index=0&id=df845522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df845522",
  null
  
)

export default component.exports